import SegmentFilterSeparator from './SegmentFilterSeparator'
import SegmentGroupComponent from './SegmentGroup'
import { GroupOperator, SegmentGroup } from './types'

interface SegmentNestedGroupsProps {
  nestedGroups: SegmentGroup[]
  parentOperator: GroupOperator
  parentHasRules: boolean
  depth: number
}

const SegmentNestedGroups = ({
  nestedGroups,
  parentOperator,
  parentHasRules,
  depth,
}: SegmentNestedGroupsProps) => {
  const nestedGroupItems = nestedGroups.map((nestedGroup, nestedIndex) => {
    const showSeparator = parentHasRules || nestedIndex > 0
    const nestedKey = nestedGroup.id || `nested-${nestedIndex}`

    return (
      <div key={nestedKey}>
        {showSeparator && <SegmentFilterSeparator operator={parentOperator} />}
        <SegmentGroupComponent
          group={nestedGroup}
          groupIndex={nestedIndex}
          depth={depth + 1}
        />
      </div>
    )
  })

  return <>{nestedGroupItems}</>
}

export default SegmentNestedGroups
